<template>
  <div id="app">
    <Header
      :user="$store.getters.getUser"
      :isLoggedIn="$store.getters.isLoggedIn"
      @logout="logout"
    />
    <router-view />
  </div>
</template>

<script>
import Header from './components/AppHeader.vue'
export default {
  components: {
    Header
  },
  methods: {
    logout () {
      this.$store.dispatch('logoutUser')
      this.$router.push({ name: 'WelcomePage' })
    }
  },
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
